import React from 'react';
import { recognizeItems } from '../data/content';
export function Recognize() {
  return <section className="w-full bg-stone-100 px-5 py-20 sm:py-24" data-id="element-172" data-mp="30xgghstmwhq5">
      <div className="mx-auto max-w-4xl" data-id="element-173" data-mp="30zaz30hfnxr2">
        <div className="text-center" data-id="element-174" data-mp="2w5yfx5viwj5p">
          <h2 className="text-[1.6rem] font-black leading-tight tracking-tight text-stone-900 sm:text-[2.2rem]" data-id="element-175" data-mp="2w4wxuhg3aweh">
            <span aria-hidden="true" data-id="element-176" data-mp="2r5aowk7ao2bh">👉 </span>Do You Recognize Yourself in
            These Situations?
          </h2>
          <p className="mt-3 text-sm text-stone-500" data-id="element-177" data-mp="2i6qa3u4uucsj">
            If you said yes to any of these — this toolkit is for you.
          </p>
        </div>

        <ul className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-178" data-mp="2d8f1tnu7kacf">
          {recognizeItems.map(item => <li key={item.text} className="flex items-start gap-3 rounded-xl bg-white px-4 py-4" data-id="element-179" data-mp="289u8m8ddiqxh">
              <span className="text-base leading-none" aria-hidden="true" data-id="element-180" data-mp="bexsmfqfj1fk">
                {item.emoji}
              </span>
              <span className="text-xs font-medium leading-snug text-stone-700" data-id="element-181" data-mp="6f33agmayjwm">
                {item.text}
              </span>
            </li>)}
        </ul>

        <p className="mt-10 text-center text-lg font-bold italic text-red-500 sm:text-xl" data-id="element-182" data-mp="3nnqfbd534cop">
          And you deserve so much more than that →
        </p>
      </div>
    </section>;
}